<div class="hint-container">
  <ng-template #hintContent>
    <ng-content></ng-content>
  </ng-template>
  <i [imTooltip]="hintContent" [position]="placement()">
    <img
      src="/assets/images/icons/icon-question.svg"
      class="question-mark"
      [alt]="'hint.information_l_a11y' | translate"
    />
  </i>
</div>
